import React from 'react';

const OurDepartments = () => {
  // Data array to make the code cleaner and easier to update
  const cardsData = [
    {
      id: 1,
      title: 'Strategic Planning',
      description: 'We help you define your business goals and create a roadmap to achieve sustainable growth through data-driven strategies.',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      linkText: 'Learn More',
      linkHref: '#'
    },
    {
      id: 2,
      title: 'Digital Marketing',
      description: 'Reach your target audience effectively with our comprehensive digital marketing campaigns, SEO, and social media management.',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      linkText: 'Learn More',
      linkHref: '#'
    },
    {
      id: 3,
      title: 'Creative Design',
      description: 'Our design team creates stunning visuals that capture your brand essence, from logos and brochures to full web interfaces.',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      linkText: 'Learn More',
      linkHref: '#'
    },
  ];

  return (
    <section className="bg-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Our Departments
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Explore what we can do for your business.
          </p>
        </div>

        {/* Responsive Grid Container */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cardsData.map((card) => (
            <div 
              key={card.id} 
              className="flex flex-col bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              {/* Card Image */}
              <div className="h-56 w-full overflow-hidden">
                <img 
                  className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500"
                  src={card.image} 
                  alt={card.title} 
                />
              </div>

              {/* Card Content */}
              <div className="flex-1 p-6 flex flex-col justify-between">
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {card.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {card.description}
                  </p>
                </div>

                {/* Link Button */}
                <div className="mt-4">
                  <a 
                    href={card.linkHref}
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
                  >
                    {card.linkText}
                    <svg className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurDepartments;